<template>
  <b-container v-if="fullLoadedData" class="p-0" fluid="true" style="overflow: auto; display: inline-block;">
    <b-row no-gutters>
      <b-col class="pl-2 pt-2 m-0">
        <h4>{{$tr('brandingParameters.productInfo','Product Info')}}</h4>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2">
        <pre style="padding: 5px;" v-html="productData"></pre>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2 m-0">
        <h4>{{$tr('brandingParameters.productMaterials','Product Materials')}}</h4>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2">
        <pre style="padding: 5px;" v-html="materialsData"></pre>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2 m-0">
        <h4>{{$tr('brandingParameters.productDynamicAttributes','Product Dynamic Attributes')}}</h4>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2">
        <pre style="padding: 5px;" v-html="dynamicAttributesData"></pre>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2 m-0">
        <h4>{{$tr('brandingParameters.ProductImages','Product Images')}}</h4>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2">
        <pre style="padding: 5px;" v-html="imagesData"></pre>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2 m-0">
        <h4>{{$tr('brandingParameters.AllDynamicAttributes','All Dynamic Attributes')}}</h4>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2">
        <pre style="padding: 5px;" v-html="allDynamicAttributes"></pre>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2 m-0">
        <h4>All Pictograms</h4>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2">
        <pre style="padding: 5px;" v-html="allPictograms"></pre>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2 m-0">
        <h4>All Images Tags</h4>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2">
        <pre style="padding: 5px;" v-html="allImagesTagsData"></pre>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2 m-0">
        <h4>{{$tr('brandingParameters.place.tags.copied','This is a place where your tags are copied')}}</h4>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="pl-2">
        <pre style="padding: 5px;" v-html="cloneData"></pre>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import Activity from "@/activity/Activity";

import hljs from 'highlight.js/lib/core';
import 'highlight.js/styles/github.css';
import xml from 'highlight.js/lib/languages/xml';
import Perms from "@/server/Perms";


hljs.registerLanguage('xml', xml);

export default {
  name: "BrandingParameters",
  permission: Perms.BRANDING_PARAMETERS,
  components: {},

  async mounted() {
    this.productData = await Rpc.plm.services.BrandingParametersService.collectPlmProductInfo().lock();
    this.materialsData = await Rpc.plm.services.BrandingParametersService.collectPlmMaterialsInfo().lock();
    this.dynamicAttributesData = await Rpc.plm.services.BrandingParametersService.collectProductDynamicAttributesInfo().lock();
    this.imagesData = await Rpc.plm.services.BrandingParametersService.collectProductImagesInfo().lock();
    let listOfInfo = await Rpc.plm.services.BrandingParametersService.collectAllDynamicAttributesAndAllPictogramsInfo().lock();
    this.allImagesTagsData = await Rpc.plm.services.BrandingParametersService.collectAllImageTagsInfo().lock();
    this.cloneData = await Rpc.plm.services.BrandingParametersService.cloneDataInfo().lock();
    this.allDynamicAttributes = listOfInfo[0];
    this.allPictograms = listOfInfo[1];
    this.productData = hljs.highlight(this.productData, {language: 'xml'}).value;
    this.materialsData = hljs.highlight(this.materialsData, {language: 'xml'}).value;
    this.dynamicAttributesData = hljs.highlight(this.dynamicAttributesData, {language: 'xml'}).value;
    this.imagesData = hljs.highlight(this.imagesData, {language: 'xml'}).value;
    this.allDynamicAttributes = hljs.highlight(this.allDynamicAttributes, {language: 'xml'}).value;
    this.allPictograms = hljs.highlight(this.allPictograms, {language: 'xml'}).value;
    this.allImagesTagsData = hljs.highlight(this.allImagesTagsData, {language: 'xml'}).value;
    this.cloneData = hljs.highlight(this.cloneData, {language: 'xml'}).value;
    this.fullLoadedData = true;
  },

  methods: {

    ...Activity.methods,

    getTitle() {
      return $tr('brandingParameters.brandingParameters','Branding Parameters');
    },
  },

  props: {},


  data: () => ({
    fullLoadedData: false,
    productData: null,
    materialsData: null,
    dynamicAttributesData: null,
    imagesData: null,
    allDynamicAttributes: null,
    allPictograms: null,
    cloneData: null,
    allImagesTagsData: null,
  }),

}
</script>